import {call, put, takeLatest} from 'redux-saga/effects';
import {
    FEE_CAT_QUERY_START,
    FeeCatQueryStartAction,
    getFeeCatQuerySuccessAction,
    getFeeCatQueryFailedAction
} from "../actions/FeeCategoryQueryAction";

import ApiUtil from "src/utils/ApiUtil";

/* A mini localstoarge cache here since node-fetch doesn't support cache */
const set = (keyName:string, keyValue:any, ttl:number) => {
    const data = {
        value: keyValue,
        ttl: Date.now() + (ttl * 1000), // in seconds
    }

    // store data in LocalStorage
    localStorage.setItem(keyName, JSON.stringify(data));
};

const get = (keyName:string) => {
    const data = localStorage.getItem(keyName);
    if (!data) {
        return null;
    }
    const item = JSON.parse(data);

    // If TTL has expired, remove the item from localStorage and return null
    if (Date.now() > item.ttl) {
        localStorage.removeItem(keyName);
        return null;
    }

    // return data if not expired
    return item.value;
};

export function* getFeeCategories(action: FeeCatQueryStartAction) {
    try {
        let parameters: any = {locale: action.locale, countryCode: action.countryCode};
        // @ts-ignore
        let response: any;
        if (get(action.locale + action.countryCode) != null){
            response = get(action.locale + action.countryCode)
        } else {
            // @ts-ignore
            response = yield call(ApiUtil.callApiWithTimeout, "getfeecategorylist", parameters);
        }
        if (response.succeed) {
            yield put(getFeeCatQuerySuccessAction(response));
            set(action.locale + action.countryCode, response, 3600); // align with backend ttl
        } else {
            yield put(getFeeCatQueryFailedAction());
        }
    } catch (error) {
        console.error("Call API getfeecategorylist error" + error)
        yield put(getFeeCatQueryFailedAction());
        return;
    }

}

export default function* feeCategory() {
    yield takeLatest([FEE_CAT_QUERY_START], getFeeCategories);
}